<template lang="pug">
  b-container#publisher-container
    b-row
      b-col.order-md-2(md="6")
        b-card
          b-row(:class="{ 'mb-3': model_id }")
            b-col.d-flex.align-items-center
              b-form-group(label="Cuenta seleccionada:")
                treeselect(:options="parsedAccounts", placeholder="- Seleccionar cuenta -", v-model="model_id", v-bind="treeselect_options", @select="accountChanged", :clearable="false")
          div(v-if="model_id")
            div.mb-3(v-if="!isPostPublished")
              p.mb-2.text-sm Publicar o agendar publicación:
              b-form-row
                b-col(md="6")
                  b-form-select(v-model="post_data.publishMode", size="sm")
                    option(value="" disabled) -- Seleccionar tipo --
                    option(v-for="opt in publish_options", :key="opt.value" :value="opt.value") {{opt.title}}
                b-col(md="6", v-if="post_data.publishMode == 'scheduled'")
                  date-range-picker.w-100.p-0.b-0(ref="date_picker_input", v-bind="calendar_props", v-model="pickedDate", @update="datePicked")
                    template(v-slot:input="picker", style="width:100%;")
                      b-input-group.mb-3(size="sm", id="date_picker_input")
                        b-form-input.readonly-white(placeholder="Seleccionar fecha...", :value="pickedDateFormatted", readonly)
                        b-input-group-append
                          b-input-group-text
                            calendar-icon.text-secondary.icon-sm
            b-form-group.mb-2(label="Contenido de publicación:", description="Puedes agregar una imagen a la publicación")
              b-form-textarea(no-resize, rows="1", max-rows="6", v-model="post_data.text", placeholder="Escribe un mensaje...", @input="unsaved_changes = true")
            div
              b-row.justify-content-between.mb-2(no-gutters)
                b-col.mb-1(cols="auto")
                  b-button.d-flex.align-items-center(v-if="!isPostPublished", variant="light", size="sm", @click="$refs.input_post_image.click()", style="border-radius:20px;")
                    camera-icon.mr-2.icon-sm
                    span.text-sm Imagen
                  img-input.mt-2(:src="post_data.media_url", @click="post_data.media_url=''", v-show="post_data.media_url")
              .text-right
                b-button(variant="primary", :disabled="isPostEmpty || loading", size="sm", @click="postPost")
                  b-spinner(small, v-if="loading", type="grow")
                  span(v-else) {{ isPostPublished ? 'Actualizar' : 'Crear' }} publicación
            b-alert.mt-3(variant="warning", :show="!isPostPublished && isPostCreated", dismissible)
              h5 Publicación pendiente
              p.mb-0 Antes de publicarla revisa que esté todo en orden. Agrega respuestas para los diferentes tipos de sentimiento en el siguiente panel.
            b-button.mt-3(variant="success", @click="publishPost", block, v-if="!isPostPublished && isPostCreated") Publicar ahora
            b-card.no-shadow.bg-light.mb-0.mt-3(v-if="isPostPublished")
              .d-flex.align-items-center.justify-content-center.text-success.mb-3
                h5.mb-0.mr-2 Publicado
                check-circle-icon.icon-md
              b-row
                b-col.text-center(cols="6")
                  p Comentarios
                  h1.mb-0 {{$compactNumber(post_data.comments)}}
                b-col.text-center(cols="6")
                  p Reacciones
                  h1.mb-0 {{$compactNumber(post_data.likes)}}
      b-col.order-md-2(md="6", v-show="post_data.public_media_id != null")
        b-card
          p.mb-2 Respuestas a comentarios:
          b-row.align-items-center.flex-nowrap.mb-2
            b-col(cols="12")
              b-tabs(justified, card)
                b-tab(title="Positivos")
                  post-answers(:post_answers="post_answers", :sentiment="'positive'", :post_id="post_data.post_id")
                b-tab(title="Neutrales")
                  post-answers(:post_answers="post_answers", :sentiment="'neutral'", :post_id="post_data.post_id")
                b-tab(title="Negativos")
                  post-answers(:post_answers="post_answers", :sentiment="'negative'", :post_id="post_data.post_id")

    b-button.mb-3(variant="success", :disabled="isPostEmpty", @click="clearData", v-if="model_id") Nueva publicación
    b-card(no-body, style="width:100%;", v-if="model_id")
      b-table.card-table.mb-0(:items="parsed_posts", :fields="fields", responsive, show-empty, selectable, select-mode="single",  selectedVariant="primary", @row-selected="rowSelected", :filter="filter", ref="posts_table")
        template(v-slot:empty="data")
          p.text-help.mb-0 No hay publicaciones
        template(v-slot:cell(media_url)="data")
          b-img.img(rounded, width="50px", height="50px", :src="data.item.media_url", v-if="data.item.media_url", @error="data.item.error = true", blank-color="#f2f2f2", :blank="data.item.error")
        template(v-slot:cell(link)="data")
          b-link(:href="data.item.link", target="blank", v-if="data.item.external_id") Ver en Facebook
          p(v-else) {{data.item.link}}
        template(v-slot:cell(actions)="data")
          trash-2-icon.icon-md.hover-danger.pointer(v-b-tooltip.hover="'Eliminar'", @click.stop="destroyPost(data.item)")
      b-pagination.mt-2(v-model="pagination_page", align="center", v-if="pagination_hasNextPage", :total-rows="100", :per-page="pagination_limit", :limit="3" @change="getPublicMedia")
    input(type="file", accept="image/*", style="display:none;", ref="input_post_image", @change="imageSelected($event)")
</template>

<script>
  import { createNamespacedHelpers, mapActions } from 'vuex'
  const public_mediaController = createNamespacedHelpers('public_media')
  const answerController = createNamespacedHelpers('answer')
  import Avatar from '../../../components/Avatar.vue'
  import PostAnswers from '../../../components/PostAnswers.vue'
  import ImgInput from '../../../components/img-input'
  import { UploadFile } from '../../../helpers/upload-file'

  const accountController = createNamespacedHelpers('account')
  import treeselectOptions from '@/data/treeselect-options'

  import Days from '@/data/days'
  import Months from '@/data/months'

  export default {
    data () {
      return {
        model_id: null,
        loading: false,
        filter: null,
        fields: [
          {
            key: 'public_media_id',
            label: 'ID'
          },
          {
            key: 'text',
            label: 'Publicación',
            //tdClass: 'post-text'
          },
          {
            key: 'media_url',
            label: 'Imagen'
          },
          {
            key: 'link',
            label: 'Link'
          },
          {
            key: 'update_date',
            label: 'Ultima Actualización'
          },
          {
            key: 'actions',
            label: 'Acciones'
          }
        ],
        facebook_data: {},
        post_data: {
          text: '',
          media_url: '',
          platform: 'facebook',
          file_image: '',
          publishMode: '',
          publish_time: '',
          is_published: false,
          public_media_id: null,
        },
        publish_options: [
          {
            title: 'Pública',
            value: 'public'
          },
          {
            title: 'Oculta',
            value: 'hide'
          },
          {
            title: 'Programada',
            value: 'scheduled'
          },
        ],
        unsaved_changes: false,
        calendar_props: {
          singleDatePicker: true,
          ranges: false,
          localeData: {
            applyLabel: 'Aplicar',
            cancelLabel: 'Cancelar',
            daysOfWeek: Days.daysShort,
            monthNames: Months.monthsShort,
            firstDay: 0
          }
        },
        pickedDate: {
          startDate: null,
          endDate: null
        },
        treeselect_options: treeselectOptions,
        facebookAccounts: []
      }
    },
    computed: {
      ...public_mediaController.mapState({
        public_media: state => state.public_media
      }),
      ...answerController.mapState({
        post_answers: state => state.answers,
      }),
      parsed_posts () {
        let self = this
        return this.public_media.map(p => {
          p.link = p.external_id ? 'https://www.facebook.com/' + p.external_id : 'No publicado'
          p.update_date = self.$moment(p.updatedAt).locale('es').format('DD [de] MMMM [del] YYYY, HH:mm a')
          return p
        })
      },
      isPostEmpty () {
        return Boolean(!this.post_data.text && !this.post_data.publishMode && !this.post_data.media_url)
      },
      isPostPublished () {
        return this.post_data.is_published
      },
      isPostCreated () {
        return Boolean(this.post_data.public_media_id)
      },
      pickedDateFormatted () {
        return this.post_data.publish_time ? this.$moment(this.post_data.publish_time).format('DD MMMM YYYY') : ''
      },
      ...accountController.mapState({
        bmessaging: state => state.bmessaging,
        bmessaging_requested: state => state.bmessaging_requested
      }),
      parsedAccounts () {
        return this.facebookAccounts.map(a => {
          return {
            id: a.model_id,
            label: a.name
          }
        })
      }
    },
    methods: {
      ...mapActions(['public_media/list', 'public_media/get', 'public_media/sync_comments', 'public_media/create', 'public_media/update', 'public_media/destroy', 'helpers/upload_file', 'answer/all', 'platform/all', 'platform/get']),
      getPublicMedia () {
        let self = this
        this.showLoadingScreen()

        this['public_media/list']({
          account_id: self.$route.params.account_id,
          params: {
            platform: 'facebook',
            model_id: self.model_id,
            ...self.paginationParams,
          },
          callback: res => {
            self.hideLoadingScreen()
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.parseResponseForPaginationData(res)
            }
          }
        })
      },
      async rowSelected (items) {
        if(!items.length) return
        if(this.unsaved_changes) {
          try {
            let response = await this.$bvModal.msgBoxConfirm(`¿Deseas continuar sin guardar los cambios?`, {
              title: 'Se perderan los cambios',
              okTitle: 'Continuar',
              cancelTitle: 'Cancelar'
            })
            if(response){
              this.getPost(items[0]);
            }
          } catch (e) {
            console.error(e.message);
          }
        } else {
          this.getPost(items[0]);
        }
      },
      getPost (row, getAll = true) {
        let self = this
        this.$scrollTo('#router-container', 300, {
          container: '#router-container',
          force: true
        })

        setTimeout(() => {
          this.showLoadingScreen()
          this['public_media/get']({
            ...row,
            params: {
              model_id: self.model_id,
            },
            callback: res => {
              self.hideLoadingScreen()
              if (res.error) {
                self.$message.error(res.error)
                if (self.$refs.posts_table)
                  self.$refs.posts_table.clearSelected()
                self.clearData()
              } else {
                self.post_data = Object.assign(self.post_data, res.resource)
                self.unsaved_changes = false
                // self.syncPost()
                if (getAll) {
                  self.getAnswers()
                  //self.getReactions()
                }
              }
            }
          })
        }, 350)
      },
      syncPost () {
        let self = this

        this['public_media/sync_comments']({
          ...self.post_data,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
            }
          }
        })
      },
      getAnswers () {
        if(!this.post_data.public_media_id) return
        let self = this

        this['answer/all']({
          post_id: self.post_data.public_media_id,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
            }
          }
        })
      },
      async clearData (force = false) {
        // clear table selection :V
        this.filter = ' '
        this.$nextTick(() => {
          this.filter = null
        })
        // :V
        if(this.unsaved_changes && !force) {
          try {
            let response = await this.$bvModal.msgBoxConfirm(`¿Deseas continuar sin guardar los cambios?.`, {
              title: 'Se perderan los cambios',
              okTitle: 'Continuar',
              cancelTitle: 'Cancelar'
            })
            if(response){
              this.post_data = {
                text: '',
                media_url: '',
                platform: 'facebook',
                file_image: '',
                publishMode: '',
                publish_time: '',
                is_published: false,
                public_media_id: null,
              }
              this.$store.commit('answer/setItems', [])
              this.unsaved_changes = false
            }
          } catch (e) {
            console.error(e.message);
          }
        } else {
          this.post_data = {
            text: '',
            media_url: '',
            platform: 'facebook',
            file_image: '',
            publishMode: '',
            publish_time: '',
            is_published: false,
            public_media_id: null,
          }
          this.$store.commit('answer/setItems', [])

          this.$scrollTo('#router-container', 500, {
            container: '#router-container',
            force: true
          })
        }
      },
      imageSelected (event) {
        let files = event.target.files

        if(files.length) {
          let file = files[0]
          try {
            this.post_data.media_url = URL.createObjectURL(file)
            this.post_data.file_image = file
          } catch (e) {
            console.log(e)
            this.$message.warning('No logramos crear la vista previa de la imagen, por favor verifica tu conexión a internet')
          }
          this.$refs.input_post_image.value = ''
        }
      },
      postPost () {
        this.post_data.public_media_id != null ? this.updatePost() : this.createPost()
      },
      async createPost () {
        var self = this
        this.loading = true

        if (this.post_data.file_image != '') {
          try {
            this.post_data.media_url = await UploadFile.call(this, this.post_data.file_image)
          } catch (e) {
            this.$message.error(e.message)
          }
        }

        this['public_media/create']({
          account_id: self.$route.params.account_id,
          platform: 'facebook',
          ...self.post_data,
          callback: res => {
            this.loading = false
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.$message.success('Publicación creada con éxito')
              self.getPost(res.resource)
            }
          }
        })
      },
      async updatePost () {
        var self = this
        this.loading = true

        if (this.post_data.file_image != '') {
          try {
            this.post_data.media_url = await UploadFile.call(this, this.post_data.file_image)
          } catch (e) {
            this.$message.error(e.message)
          }
        }

        this['public_media/update']({
          account_id: self.$route.params.account_id,
          ...self.post_data,
          callback: res => {
            this.loading = false
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.$message.success('Publicación actualizada')
              this.unsaved_changes = false
              self.getPost(self.post_data, false)
            }
          }
        })
      },
      async destroyPost (data) {

        try {
          let response = await this.$bvModal.msgBoxConfirm(`La publicación también se borrará en Facebook.`, {
            title: 'Eliminar publicación',
            okTitle: 'Continuar',
            cancelTitle: 'Cancelar'
          })
          if(response){
            let self = this
            this['public_media/destroy']({
              ...data,
              callback: res => {
                if (res.error) {
                  self.$message.error(res.error)
                } else {
                  self.$message.success('Publicación eliminada')
                  if (self.post_data.post_id == data.post_id)
                    self.clearData(true)
                }
              }
            })
          }
        } catch (e) {
          console.error(e.message);
        }
      },
      datePicked (dates) {
        this.post_data.publish_time = this.$moment(dates.startDate).format('YYYY-MM-DD')
      },
      getPlatforms () {
        let self = this

        this['platform/all']({
          account_id: self.$route.params.account_id,
          callback: async (res) => {
            if (res.error) {
              self.$message.error(res.error)
            } else {
              if (Array.isArray(res.resource)) {
                for (let platform of res.resource) {
                  if (platform.name == 'facebook') {
                    self.getPlatformData(platform)
                    break
                  }
                }
              } else {
                self.$message.warning('No tienes la plataforma Facebook activa en tu cuenta')
              }
            }
          }
        })
      },
      getPlatformData (platform) {
        let self = this

        self['platform/get']({
          account_id: self.$route.params.account_id,
          platform_id: platform.platform_id,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.facebookAccounts = res.resource.slice()
            }
          }
        })
      },
      accountChanged () {
        this.$nextTick(() => {
          this.getPublicMedia()
        })
      },
      publishPost () {
        this.post_data.publishMode = 'public'
        this.updatePost()
      }
    },
    mounted () {
      this.getPlatforms()
    },
    watch: {
      model_id (value) {
        if (!value) {
          this.facebookAccounts = []
        }
      }
    },
    components: { Avatar, ImgInput, PostAnswers }
  }
</script>

<style lang="scss" scoped>
  .absolute {
    position: absolute;
  }
</style>
